export const links = {
  facebook: 'https://www.facebook.com/Art-of-Misia-Martyna-Zar%C4%99ba-578982875465162/',
  instagram: 'https://www.instagram.com/art.of.misia/',
  youtube: 'https://www.youtube.com/channel/UCOZD3QI5WQ-eddUpD1z1BYw'
}